import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';

import {
  DetailsButton,
  StyledLoyaltyRewardsLogo,
  TextContainer,
  UnauthenticatedContainer,
  WelcomeMessage,
} from './loyalty-banner.styled';

const UnauthenticatedBanner: FC = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(formatMessage({ id: 'routes.loyaltyBannerUnauthenticated' }));
  };

  return (
    <UnauthenticatedContainer data-testid="unauthenticated-banner">
      <TextContainer>
        <StyledLoyaltyRewardsLogo />
        <WelcomeMessage>{formatMessage({ id: 'loyaltyBannerLoggedOutMessage' })}</WelcomeMessage>
      </TextContainer>
      <DetailsButton
        size={ActionButtonSizes.SMALL}
        variant={ActionButtonVariants.OUTLINE}
        onClick={handleClick}
      >
        {formatMessage({ id: 'loyaltyBannerDetailsButtonLabel' })}
      </DetailsButton>
    </UnauthenticatedContainer>
  );
};

export default UnauthenticatedBanner;
